module.exports = __webpack_public_path__ + "img/robot1.a19c6679.png";